import React, { Dispatch, memo, ReactNode, SetStateAction, useState } from 'react';
import { Box, Card, CardActionArea, CardContent, Typography, Tooltip } from '@mui/material';
import { useTranslation, withTranslation } from 'react-i18next';
import { classNames } from '../../../utils/classNames';
import { selectionCardGroupStyles } from './style';
import { getResponsiveSize } from '../../../utils';

export interface SelectionCardOption {
  value: any;
  Icon: ReactNode;
  label: string;
}

interface SelectionCardGroupProps {
  options: SelectionCardOption[];
  name?: string;
  className?: string;
  title: string;
  trajectory: number;
  setTrajectory: Dispatch<SetStateAction<number>>;
  setOff: Dispatch<SetStateAction<boolean>>;
  eyeMovement: boolean;
}

export const SelectionCardGroup = (props: SelectionCardGroupProps) => {
  const { className, options, trajectory, setTrajectory, title, setOff, eyeMovement } = props;
  const { t } = useTranslation();
  const { selectionCardGroup } = selectionCardGroupStyles;
  const [displayValue, setDisplayValue] = useState(trajectory);
  const toId = (label: string) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-');

  const onChangeTrajectory = (value: number) => {
    if (value === 5) {
      setOff(!eyeMovement);
    } else {
      if (!eyeMovement) {
        setOff(!eyeMovement);
      }
    }

    setDisplayValue(value);
    if (value <= 0 || value >= 5) {
      value = 0;
    }
    setTrajectory(value);
  };

  return (
    <Box sx={selectionCardGroup} className={classNames(className || '')}>
      <Tooltip
        placement="left-start"
        title={
          <Typography
            color="inherit"
            style={{ fontSize: getResponsiveSize(11) }}
            dangerouslySetInnerHTML={{ __html: t('trajectory-tooltip') }}
          />
        }
      >
        <Box className="title-container">
          <Typography className="title">{title}</Typography>
        </Box>
      </Tooltip>
      <Box className="items-container">
        <Box className="row row-1">
          {options.slice(0, 2).map(option => (
            <Card
              key={`${option?.label}-${option?.value}`}
              className={classNames(option?.label, { active: displayValue === option?.value }, ['card'])}
              onClick={() => onChangeTrajectory(option?.value)}
              data-testid={`pwid-trajectory-${toId(option?.label)}`}
            >
              <CardActionArea>
                <Box className={`icon ${option?.label}`}>{option.Icon}</Box>
                <CardContent>
                  <Typography className="desc" variant="h5">
                    {t(`${option?.label}`)}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
        <Box className="row row-2">
          {' '}
          {/* Second row */}
          {options.slice(2).map(option => (
            <Card
              key={`${option?.label}-${option?.value}`}
              className={classNames(option?.label, { active: displayValue === option?.value }, ['card'])}
              onClick={() => onChangeTrajectory(option?.value)}
              data-testid={`pwid-trajectory-${toId(option?.label)}`}
            >
              <CardActionArea>
                <Box className="icon">{option.Icon}</Box>
                <CardContent>
                  <Typography className="desc" variant="h5">
                    {t(`${option?.label}`)}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
